import swal from "sweetalert2/dist/sweetalert2.js";
import loadingImage from "@/assets/images/alert-loading.gif";

export default {
  dialogBox(action) {
    swal
      .fire({
        title: "Are you sure?",
        showCancelButton: true,
        confirmButtonColor: "#2C4BFF",
        cancelButtonColor: "#989797",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        preConfirm: false,
        // customClass: 'sweetalert-lg'
      })
      .then((result) => {
        if (result.value) {
          action();
          swal.fire({
            title: "Loading!",
            imageUrl: loadingImage,
            imageWidth: 50,
            imageHeight: 50,
            imageAlt: "loading",
            showConfirmButton: false,
            customClass: "sweetalert-lg",
          });
        }
      });
  },

  close() {
    swal.close();
  },

  alertBox(title, timer, type, _callback = null) {
    swal
      .fire({
        title: title,
        timer: timer,
        type: type,
        showConfirmButton: false,
        customClass: "sweetalert-lg",
      })
      .then(() => {
        if (_callback && typeof _callback === "function") _callback();
      });
  },
};



// WEBPACK FOOTER //
// ./src/helpers/sweetAlert.js